// @flow

import * as React from 'react';

type ErrorType = { message?: string };

type Props = {
  error: {
    graphQLErrors?: Array<ErrorType>,
    networkErrors?: Array<ErrorType>,
    message: string,
  },
  children: (Array<?string>) => React.Node,
};

const ErrorParser = (props: Props) => {
  let errors = [];
  const {
    error: { graphQLErrors, networkErrors, message },
  } = props;

  if (graphQLErrors && Array.isArray(graphQLErrors)) {
    errors = [
      ...errors,
      ...graphQLErrors.map((e: ErrorType) => e && e.message),
    ];
  }

  if (networkErrors && Array.isArray(networkErrors)) {
    errors = [
      ...errors,
      ...networkErrors.map((e: ErrorType) => e && e.message),
    ];
  }

  const finalErrors = errors && errors.length === 0 ? [message] : errors;

  return props.children(finalErrors);
};

export default ErrorParser;
